import { AxiosRequestConfig, InternalAxiosRequestConfig } from "axios";

export interface IRawPagedResponse<TValue>
{
    "@odata.nextLink": (string | null);
    Value: TValue;
}

export interface IRawPagedResponse2<TValue>
{
    httpStatusCode: number;
    nextToken: string;
    results: TValue;
}

export interface IRawPagedResponse3<TValue>
{
    "@odata.nextLink": (string | null);
    value: TValue;
}

export interface IRawPagedResponseBookingSeries<TValue>
{
    "OdataNextLink": (string | null);
    Booking: TValue;
}

export class PagedResponse<TValue>
{
    public skipToken: string;
    public value: TValue;

    constructor(data: { skipToken: string, value: TValue })
    {
        this.skipToken = data.skipToken;
        this.value = data.value;
    }
}

export class ODataSelect
{
    public init(response: any, nodeId: number): ODataSelect
    {
        Object.assign(this, response);
        return this;
    }

    public toSelect(): string
    {
        return Object.entries(this).map(i => i[0]).join(",");
    }

    public toExpand(): string
    {
        return "";
    }
}

export interface IbssRequestConfig extends AxiosRequestConfig
{
    tokenRefreshed?: boolean;
    suppressErrorPopup?: boolean;
}

export interface IAxiosRequestConfig extends InternalAxiosRequestConfig
{
    tokenRefreshed?: boolean;
    suppressErrorPopup?: boolean;
}
